import { render, staticRenderFns } from "./Stay.vue?vue&type=template&id=95e681e8&scoped=true&"
import script from "./Stay.vue?vue&type=script&lang=ts&"
export * from "./Stay.vue?vue&type=script&lang=ts&"
import style0 from "./Stay.vue?vue&type=style&index=0&id=95e681e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e681e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e681e8')) {
      api.createRecord('95e681e8', component.options)
    } else {
      api.reload('95e681e8', component.options)
    }
    module.hot.accept("./Stay.vue?vue&type=template&id=95e681e8&scoped=true&", function () {
      api.rerender('95e681e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/v2/Stay.vue"
export default component.exports